import React from "react";
import GridCard from "./GridCard";
import LoadingGridCard from "./LoadingGridCard";

function mockProducts() {
    const products = [];

    for (let i = 0; i < 3; i++) {
        products.push({
            "Id": i
        })
    }

    return products;
}

export default function ProductListGrid(props) {

    const { products,
        isLoading } = props;

    return (
        <div className="product-list-grid">
            {
                !isLoading ?
                    products.map((product, i) => (
                        <GridCard key={`product-${i}`} {...props} product={product} Productindex={""+i} />
                    ))
                    :
                    mockProducts().map((product, i) => (
                        <LoadingGridCard key={`product-${i}`} />
                    ))
            }
        </div>
    );
}